import { loadMessages, formatMessage } from 'devextreme/localization'

export default {

    carregaTraducao(arquivos) {
        for (let i in arquivos) {
            loadMessages(arquivos[i])
        }
    },

    // Nota: se precisar mandar mais de uma parâmetro nas variáveis, enviar como array
    // Ex: Se 'nome-sobrenome' é igual a 'Nome: {0}, Sobrenome: {1}'
    //     this.$vistra.globalize('nome-sobrenome', ['Fabio', 'Zanardi']) 

    globalize(chave, variaveis = undefined) {
        let retorno = ''; //pra debug
        try {
            retorno = formatMessage(chave, variaveis)
        }
        catch (e) {
            retorno = "[ND]"
        }
        return retorno;
    },

    globalizeDef(chave, variaveis) {
        let retorno = this.globalize(chave, variaveis);
        if (!retorno.length)
            return chave;
        return retorno;
    },
    
    idiomas() {
        return [
            { id: "pt", nome: this.globalize("idioma-portugues") },
            { id: "en", nome: this.globalize("idioma-ingles") },
            { id: "es", nome: this.globalize("idioma-espanhol") }
        ]
    },

    moedas() { 
        return [
            { id: "BRL", nome: `BRL - R$ - ${this.globalize("moeda-real-brasileiro")}` }, 
            { id: "USD", nome: `USD - $ - ${this.globalize("moeda-dolar-americano")}` }, 
            { id: "PYG", nome: `PYG - ₲ - ${this.globalize("moeda-guarani-paraguaio")}` }
        ]
    }
}
